import { ReactElement } from 'react';
import { SelectField, TextField } from '@ff-it/form';
import { Fieldset, FormInlineError } from 'components';
import { resetPeriodOptions } from 'configuration';
import { CampaingSequenceFieldset } from '../CampaingSequenceFieldset';

function SequenceFieldset({ name, title, help }: { name: string; title: string; help: string }): ReactElement {
  return (
    <Fieldset title={title}>
      <FormInlineError name={name} />
      <div className="form-row">
        <TextField
          name={`${name}.format`}
          className="col-md-6 mb-0"
          size="sm"
          placeholder="Format"
          help={help}
          required
        />
        <SelectField
          name={`${name}.reset_period`}
          placeholder="Reset period"
          className="col-md-6 mb-0"
          size="sm"
          required
          options={resetPeriodOptions}
          simple
        />
      </div>
    </Fieldset>
  );
}

export function SequencesFields({ disabled = false }: { disabled?: boolean }): ReactElement {
  return (
    <>
      <div className="row">
        <div className="col-6">
          <SequenceFieldset name="invoice_sequence" title="Invoice sequence" help="{enterprise}####{suffix}" />
          <SequenceFieldset name="acceptance_sequence" title="Acceptance act sequence" help="PNA-YYYYMMDD-#####" />
        </div>
        <div className="col-6">
          <SequenceFieldset
            name="client_agreement_sequence"
            title="Client agreement sequence"
            help="{enterprise}-{client}-MM.YYYY/#"
          />
          <SequenceFieldset
            name="provider_agreement_sequence"
            title="Provider agreement sequence"
            help="{enterprise}-{provider}-MM.YYYY/#"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <CampaingSequenceFieldset disabled={disabled} />
        </div>
      </div>
    </>
  );
}
